module.exports = __webpack_public_path__ + "img/20200416141921481.2d00a34b.png";